export var SecurityRoleItems = {
  Dashboard: "Dashboard",
  MyJobs: "My Jobs",
  MyRequisition: "My Requisition",
  MyCommunications: "My Communications",
  MyCalendar: "My Calendar",
  MyTalentPools: "My Talent Pools",
  MySavedSearches: "My Saved Searches",
  MyNotes: "My Notes",
  Jobs: "Jobs",
  TalentPool: "Talent Pool",
  TalentCapture: "Talent Capture",
  TalentCommunity: "Talent Community",
  SearchCandidates: "Search Candidates",
  SearchByKeywords: "Search By Keywords",
  SearchbyPostcode: "Search by Postcode",
  SaveSearch: "Save Search",
  SmartSearch: "AllowTextKernelSearch",
  AllowApplicationSearch: "AllowApplicationSearch",
  AssignToTalentPool: "Assign To Talent Pool",
  SearchJobAlerts: "Search Job Alerts",
  CalendarEntries: "Calendar Entries",
  ListofEvents: "List of Events",
  Emails_EmailTemplates: "Emails: Email Templates",
  Emails_Inbox: "Emails: Inbox",
  Emails_Outbox: "Emails: Outbox",
  Letters_LetterTemplates: "Letters: Letter Templates",
  Letters_LetterContracts: "Letters: Contracts",
  Letters_LetterContractSections: "Letters: Contract Sections",
  SMS_SMSTemplates: "SMS: SMS Templates",
  SMS_Inbox: "SMS: Inbox",
  SMS_Outbox: "SMS: Outbox",
  SystemSetup_SystemSettings: "System Setup: System Settings",
  SystemSetup_SystemUsers: "System Setup: System Users",
  SystemSetup_SecurityRoles: "System Setup: Security Roles",
  SystemSetup_Teams: "System Setup: Teams",
  SystemSetup_RequisitionUsers: "System Setup: Requisition Users",
  SystemSetup_RequisitionSchemes: "System Setup: Requisition Schemes",
  AssessmentForms_AssessmentFormSetup: "Assessment Forms: Assessment Form Setup",
  AssessmentForms_QuestionsBank: "Assessment Forms: Questions Bank",
  ApplicationTemplates: "Application Templates",
  ApplicationTemplates_TemplatesSetup: "Application Templates: Templates Setup",
  ApplicationTemplates_CustomFields: "Application Templates: Custom Fields",
  GeneralSetup: "General Setup",
  GeneralSetup_Languages: "General Setup: Languages",
  GeneralSetup_Package: "General Setup: Package",
  GeneralSetup_JobCode: "General Setup: JobCode",
  GeneralSetup_GBGroupPin: "General Setup- GB Group Pins",
  GeneralSetup_DocumentLibrary: "General Setup: Document Library",
  GeneralSetup_Adverts: "General Setup: Adverts",
  GeneralSetup_ExternalConsultancies: "General Setup: External Consultancies",
  GeneralSetup_AdvertCategories: "General Setup: Advert Categories",
  GeneralSetup_JobCategories: "General Setup: Job Categories",
  GeneralSetup_JobRegions: "General Setup: Job Regions",
  GeneralSetup_StandardApplicationStatus: "General Setup: Standard Application Status",
  GeneralSetup_SalaryBands: "General Setup: Salary Bands",
  GeneralSetup_EthnicOrigins: "General Setup: Ethnic Origins",
  GeneralSetup_Departments: "General Setup: Departments",
  GeneralSetup_Locations: "General Setup: Locations",
  GeneralSetup_JobLevels: "General Setup: Job Levels",
  GeneralSetup_Divisions: "General Setup: Divisions",
  GeneralSetup_Campaigns: "General Setup: Campaigns",
  GeneralSetup_JobTitles: "General Setup: Job Titles",
  GeneralSetup_AddressBook: "General Setup: Address Book",
  GeneralSetup_SchoolLocations: "General Setup: School Locations",
  GeneralSetup_SkillCategory: "General Setup- Skill Category",
  GeneralSetup_StatusChangeReason: "General Setup: Status Change Reason",
  GeneralSetup_Skills: "General Setup- Skills",
  GeneralSetup_NHSAccountCodes: "General Setup- NHSAccountCodes",
  GeneralSetup_NHSCostCodes: "General Setup- NHSCostCodes",
  GeneralSetup_NHSBoardPositions: "General Setup- NHSBoardPositions",
  SystemSetup: "System Setup",
  AssessmentForms: "Assessment Forms",
  Emails: "Emails",
  Letters: "Letters",
  SMS: "SMS",
  Candidates: "Candidates",
  JobAlerts: "Job Alerts",
  ListCandidate: "List Candidate",
  Reports: "Reports",
  ListCandidate_History: "List Candidate - History",
  ListCandidate_CV: "List Candidate - CV",
  ListCandidate_Interview: "List Candidate - Interview",
  ListCandidate_UpdateStatus: "List Candidate - Update Status",
  ListCandidate_AssigntoaJob: "List Candidate - Assign to a Job",
  ListCandidate_AssigntoaTalentPool: "List Candidate - Assign to a Talent Pool",
  ListCandidate_AddNotes: "List Candidate - Add Notes",
  ListCandidate_Checklist: "List Candidate - Checklist",
  ListCandidate_StarterForm: "List Candidate - Starter Form",
  ListCandidate_StarterForm2: "List Candidate - Starter Form2",
  ListCandidate_StartOnboarding: "List Candidate - Start Onboarding",
  ListCandidate_StartReferences: "List Candidate - Start References",
  ListCandidate_SendEmail: "List Candidate - Send Email",
  ListCandidate_SendLetter: "List Candidate - Send Letter",
  ListCandidate_ForwardDetails: "List Candidate - Forward Details",
  ListCandidate_EmailReference: "List Candidate - Email Reference",
  ListCandidate_LetterReference: "List Candidate - Letter Reference",
  ListCandidate_PrintContract: "List Candidate - Print Contract",
  ListCandidate_OpportunityAlerts: "List Candidate - Opportunity Alerts",
  ListCandidate_AppliedJobs: "List Candidate - Applied Jobs",
  ListCandidate_ExternalInternal: "List Candidate - External/Internal",
  ListCandidate_EmailNewPassword: "List Candidate - Email New Password",
  ListCandidate_UnlockAccount: "List Candidate - Unlock Account",
  ListCandidate_ViewUpdateDocuments: "List Candidate - View & Update Documents",
  ListCandidate_SentEmails: "List Candidate - Sent Emails",
  ListCandidate_SentTextMessages: "List Candidate - Sent Text Messages",
  ListCandidate_SentLetters: "List Candidate - Sent Letters",
  ListCandidate_OfferAuthorisation: "List Candidate - Offer Authorisation",
  ListCandidate_SendText: "List Candidate - Send Text",
  ListCandidate_eEssForm: "List Candidate - eEss Form",
  ListCandidate_Psychometrics: "List Candidate - Psychometrics",
  ListCandidate_VideoInterview: "List Candidate - Video Interview",
  ListCandidate_PrintExport: "List Candidate - Print & Export",
  ListCandidate_Shortlisting: "List Candidate - Shortlisting",
  SystemSetup_MultipleDocumentsUpload: "System Setup: Multiple Documents Upload",
  ListCandidate_2ndStageApplication: "List Candidate - 2nd Stage Application",
  ListCandidate_BullkForward: "List Candidate - Bullk Forward",
  ListCandidate_ForwardSingle: "List Candidate - Forward Single",
  ListCandidate_SpecialAdjustment: "List Candidate - Special Adjustment",
  ListCandidate_Preassessment: "List Candidate - Pre-assessment",
  AlertsSetup: "Alerts Setup",
  Alerts_ListTemplates: "Alerts: List Templates",
  OnboardingSetup_List: "Onboarding Setup: List",
  Onboarding_Settings: "Onboarding: Settings",
  Onboarding_DocumentLibrary: "Onboarding: Document Library",
  Onboarding_Templates: "Onboarding: Templates",
  Onboarding_DocumentTypes: "Onboarding: Document Types",
  GeneralSetup_SchoolSubjects: "General Setup: School Subjects",
  GeneralSetup_WorkLevels: "General Setup: Work Levels",
  GeneralSetup_CostCentres: "General Setup: Cost Centres",
  ListCandidate_CompareShortlisting: "List Candidate - Compare Shortlisting",
  ListCandidate_OnlineDisclosure: "List Candidate - Online Disclosure",
  ListCandidate_DownloadCV: "List Candidate - DownloadCV",
  ListCandidate_EmailAgency: "List Candidate - Email Agency",
  MediaLibrary: "Media Library",
  MediaLibrary_Images: "Media Library: Images",
  MediaLibrary_Videos: "Media Library: Videos",
  MediaLibrary_TextualContents: "Media Library: Textual Contents",
  MediaLibrary_TextContents: "Media Library: Text Contents",
  Onboarding_AssessmentForm: "Onboarding: Assessment Form",
  ListCandidate_Reassigntorecruiter: "List Candidate - Reassign to recruiter",
  ListCandidate_RemovefromRecruiter: "List Candidate - Remove from Recruiter",
  ListCandidate_DeferredCandidate: "List Candidate - Deferred Candidate",
  SystemSettings: "System Setup: System Settings",
  OnboardingSettings: "Onboarding: Settings",
  SystemSetupSystemSettings: "System Setup: System Settings",
  SystemSetupSystemUsers: "System Setup: System Users",
  SystemSetupSecurityRoles: "System Setup: Security Roles",
  SystemSetupTeams: "System Setup:Teams",
  SystemSetupRequisitionUsers: "System Setup: Requisition Users",
  SystemSetupMultipleDocumentsUpload: "System Setup: Multiple Documents Upload",
  SystemSetupRequisitionSchemes: "System Setup: Requisition Schemes",
  AssessmentFormsAssessmentFormSetup: "Assessment Forms: Assessment Form Setup",
  AssessmentFormsQuestionsBank: "Assessment Forms: Questions Bank",
  AssessmentFormsTimedAssessmentFormSetup: "Assessment Forms: Timed Assessment Form Setup",
  AssessmentFormsJTFormsSetup: "Assessment Forms: JT Form Setup",
  GreenRoomSetup: "Green Room Setup",
  GreenRoom: "Green Room",
  ListAlertsTemplates: "Alerts: List Templates",
  ListCandidateArchiveApplication: "List Candidate - Archive Application",
  ListCandidate_ResetTest: "List Candidate - Reset Test",
  UserSettings: "User Settings",
  CalendarIsPrivate: "CalendarIsPrivate",
  GreenRoom_Manager: "Green Room: Manager",
  GreenRoom_Links: "Green Room: Links",
  GreenRoom_Contacts: "Green Room: Key Contacts",
  ListCandidate_OAAcceptReject: "List Candidate - OA Accept & Reject",
  ListCandidate_CandidatePack: "List Candidate - Candidate Pack",
  ListCandidate_MoveToJob: "List Candidate - Move To Job",
  ListCandidate_BulkStatusUpdate: "List Candidate - Bulk Status Update",
  ListCandidate_ScreeningForm: "List Candidate - Screening Form",
  ListCandidate_Ranking: "List Candidate - Ranking",
  ListCandidate_ShortlistingComplete: "List Candidate - Shortlisting Complete",

  AllowAlerts: "AllowAlerts",
  AllowCalendar: "AllowCalendar",
  AllowEmails: "AllowEmails",
  AllowJobs: "AllowJobs",
  AllowLetter: "AllowLetter",
  AllowSearch: "AllowSearch",
  AllowSettingsAf: "AllowSettingsAf",
  AllowSettingsAt: "AllowSettingsAt",
  AllowSettingsGs: "AllowSettingsGs",
  AllowSettingsMl: "AllowSettingsMl",
  AllowSettingsSs: "AllowSettingsSs",
  AllowSms: "AllowSms",
  AllowTalentPools: "AllowTalentPools",
  AllowSettingsOBs: "AllowSettingsOBs",
  AllowSettingsGRs: "AllowSettingsGRs",
  ListCandidate_StartDBSCheck: "List Candidate - Start DBS Check",
  AddAjobAllowTemplate: "AddAjobAllowTemplate", //"AddAjobAllowTemplate"
  AddAjobAllowCopy: "AddAjobAllowCopy",
  AddAjobAllowCreate: "AddAjobAllowCreate",
  GreenRoomTemplate: "Green Room: Template",
  Feature_GreenRoom:"Feature_GreenRoom",
  ViewAllJobs: "ViewAllJobs",
  FeatureMyJobs: "FeatureMyJobs",
  Feature_Onboarding: "FeatureOnboarding",
  JobAdvertCopy: "JobAdvertCopy",
  FormAssessment: "FormAssessment",
  JobMatch: "JobMatch",
  JobAdditionalInfo: "JobAdditionalInfo",
  JobAccess: "JobAccess",
  JobPostTheJob: "JobPostTheJob",
  AllowListByStatuses: "AllowListByStatuses",
  MyNewStarters: "My New Starters",
}


export var SecurityRoleMainMenu = {
  Search: "Search",
  Reports: "Reports",
  JobsAndTalentPools: "Jobs & Talent Pools",
  Calendar: "Calendar",
  Settings: "Settings",
  SettingsControl: "SettingsControl",
  //  Reports
  //Search

  //Jobs & Talent Pools
  //Communications
  //My Workspace

}

export var SecurityRoleSubMenu = {
  AlertsSetup: "Alerts Setup",
  ApplicationTemplates: "Application Templates",
  //Assessment Forms
  //Candidates
  Emails: "Emails",
  //General Setup
  //Gernal Setup
  //Green Room
  //Job Alerts
  Letters: "Letters",
  //Media Library
  //Onboarding Setup
  SMS: "SMS"
  //System Setup
}
export var WhiteLabelSecuritySettings={
 
  SelfServiceCalendar: "SelfServiceCalendar",
  AlertModule: "AlertModule",
  secondStage: "2ndStage",
  AssessmentForms: "AssessmentForms",
  Forwardapplication: "Forwardapplication",
  AcknowledgementEmail: "AcknowledgementEmail",
  SmartMatch: "SmartMatch",
  ApprovalForm: "ApprovalForm",
  InternalAdvert: "InternalAdvert",
  AgencyAdvert: "AgencyAdvert",
  Agencies: "Agencies",
  Shortlister: "Shortlister",
  Agency: "Agency",
  Division: "Division",
  Skills: "Skills",
  PreAssessmentForm: "Pre-Assessment Form",
  Shortlisting:"Shortlisting"
}

export var MediaRichEnum = {
  image250:"assets/images/250x250.jpg",
  image750:"assets/images/750x250.jpg",
}
